import { FormEventHandler, useCallback } from "react";
import { PersonalInfoFields } from "./form/PersonalInfoFields";
import { RoleSelect } from "./form/RoleSelect";
import { FormActions } from "./form/FormActions";
import { FormWarningBanner } from "./form/FormWarningBanner";
import { useEmployeeForm } from "@/hooks/useEmployeeForm";
import { Employee, ExtendedRole } from "./types";
import { AppRole } from "@/types/database/auth";

interface EmployeeFormProps {
  employee: Employee | null;
  isNewEmployee: boolean;
}

export const EmployeeForm = ({ employee, isNewEmployee }: EmployeeFormProps) => {
  const { formData, saving, handleFieldChange, handleSubmit } = useEmployeeForm(employee, isNewEmployee);

  const onSubmit: FormEventHandler<HTMLFormElement> = useCallback((e) => {
    handleSubmit(e);
  }, [handleSubmit]);

  const handleRoleChange = (value: ExtendedRole) => {
    handleFieldChange('role', value);
  };

  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <FormWarningBanner />
      <PersonalInfoFields
        firstName={formData.first_name}
        lastName={formData.last_name}
        email={formData.email}
        phone={formData.phone}
        password={formData.password}
        onFieldChange={handleFieldChange}
        isNewEmployee={isNewEmployee}
      />
      <RoleSelect
        value={formData.role}
        onRoleChange={handleRoleChange}
      />
      <FormActions
        isNewEmployee={isNewEmployee}
        employeeId={employee?.id}
        saving={saving}
      />
    </form>
  );
};